/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { PrimaryDrawer } from "../../Drawer/PrimaryDrawer";
import { currencyFormat, idNamingConversion } from "../../../../../helpers/utilities";
import ReportModal from "../../ReportModal";
import { AutoCompleteComponent } from "../../AutoCompleteComponent";
import { useDispatch, useSelector } from "react-redux";
import customStyles from "../../../../../assets/styles/customStyles";
import { emptyValidation } from "../../../../../helpers/validation";
import groupActions from "../../../../Sales/Setup/redux/actions";
import salesActions from "../../../../Sales/Management/redux/actions";
import salesDashboardActions from "../../../../Sales/Dashboard/redux/actions";
import { Button, Box } from "@mui/material";
import DateIcon from "../../Icons/Date";
import clsx from "clsx";
import { Space, Col, Row } from 'antd';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import moment from 'moment';



export const CustomerAgedDues = (props) => {
    const { visible, title, onCustomerAgedDuesVisible } = props;
    const { businessDetails } = useSelector(state => state.homeReducer);
    const { customerAgedDuesLoader, customerAgedDuesDetails } = useSelector(state => state.salesDashboardReducer);
    const [reportOpen, setReportOpen] = useState(false);
    const { customerDetails } = useSelector(state => state.salesManagementReducer);
    const { customerGroupdetails } = useSelector(state => state.salesSetupReducer);
    const [form, setForm] = useState({});
    const [error, setError] = useState({});


    const dispatch = useDispatch();


    useEffect(() => {
        if (visible) {
            dispatch({
                type: groupActions.CUSTOMERGROUP_DETAILS_START, url: 'customer-group', filter: {
                    order: 'id  desc'
                }
            });
            dispatch({
                type: salesActions.CUSTOMER_DETAILS_START, url: 'customerProfile', filter: {
                    order: 'id desc'
                }
            });
        }
    }, [visible])

    const handleClose = () => {
        onCustomerAgedDuesVisible(false);
        setForm({});
        setError({});
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const onChangeHandler = (e, name = '') => {
        if (name !== '') {
            if (name === 'customerId') {
                setForm({
                    ...form,
                    'groupId': '',
                    [name]: e,
                });
            } else if (name === 'groupId') {
                setForm({
                    ...form,
                    [name]: e,
                    'customerId': ''
                });
            } else {
                setForm({
                    ...form,
                    [name]: e
                });
            }
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }

    }

    const agedDuesFilter = (e) => {
        e.preventDefault();
        let emptyDueDate = emptyValidation('Due Date', form.dueDate);

        if (emptyDueDate.isValid) {
            let url = '';
            if (form?.groupId) {
                url = 'customerDueReport/?filter[where][dueDate][lte]=' + moment(form?.dueDate).format('YYYY-MM-DD') + '&filter[include][][relation]=customer&filter[include][0][scope][where][groupId]=' + form.groupId
            } else if (form?.customerId) {
                url = 'customerDueReport/?filter[where][dueDate][lte]=' + moment(form?.dueDate).format('YYYY-MM-DD') + '&filter[where][customerId]=' + form.customerId + '&filter[include][][relation]=customer'
            } else {
                url = 'customerDueReport/?filter[where][dueDate][lte]=' + moment(form?.dueDate).format('YYYY-MM-DD') + '&filter[include][][relation]=customer'
            }
            dispatch({ type: salesDashboardActions.CUSTOMER_AGED_DUES_START, url: url });
            setReportOpen(true);
            onCustomerAgedDuesVisible(false);
        } else {
            setError({
                'dueDate': emptyDueDate.errors,
                'customerId': (form?.customerId === '' && form?.groupId === '') ? 'Please Choose Customer or Group' : false
            })
        }
    }

    const classes = customStyles();
    return (
        <>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={title}
                width={"360px"}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => agedDuesFilter(e)}>
                        <div className={classes.customFormFlex}>
                            <div className={clsx(classes.dateAdjust)}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDatePicker
                                        fullWidth
                                        slots={{
                                            openPickerIcon: DateIcon
                                        }}
                                        allowKeyboardControl={false}
                                        views={['year', 'month', 'day']}
                                        value={form.duedate}
                                        //label={["Select Due Date ", <span key="Select Due Date" className={classes.colorRedRequired}> *</span>]}
                                        name={"dueDate"}
                                        PopperProps={{
                                            className: classes.dateAdjust,
                                        }}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor
                                            }
                                        }}
                                        slotProps={{
                                            textField: {
                                                label: ["Select Due Date ", <span key="Select Due Date" className={classes.colorRedRequired}> *</span>],
                                                fullWidth: true,
                                                error: error?.dueDate && true,
                                                helperText: error?.dueDate,
                                                id: idNamingConversion('Select Due Date', 'customerAgedDues', 'TextField')
                                            },
                                        }}
                                        format="dd/MM/yyyy"
                                        onChange={(newValue, newError) => {
                                            if (newError?.validationError) {
                                                onChangeHandler('', 'dueDate')
                                            } else {
                                                onChangeHandler(newValue, 'dueDate');
                                            }
                                        }}
                                    />
                                </LocalizationProvider>
                            </div>
                            <AutoCompleteComponent
                                name={["Customer Name "]}
                                heads={[{ 'key': 'name', 'name': 'Customer Name' },
                                { 'key': 'mobile', 'name': 'Phone Number' },
                                { 'key': 'serialNo', 'name': 'Customer ID' }]}
                                details={customerDetails}
                                id={idNamingConversion('Customer Name', 'customerAgedDues', 'DropDown')}
                                parentValue={customObject(customerDetails, form?.customerId)}
                                onChange={(data) => onChangeHandler(data.id, 'customerId')}
                                position={"bottom"}
                                customClasses={classes.margin20t}
                                parentError={error?.customerId}
                            />
                            <AutoCompleteComponent
                                name={["Group Name"]}
                                heads={[{ 'key': 'name', 'name': 'Name' },
                                { 'key': 'description', 'name': 'Description' }]}
                                details={customerGroupdetails}
                                id={idNamingConversion('Group Name', 'customerAgedDues', 'DropDown')}
                                parentValue={customObject(customerGroupdetails, form?.groupId)}
                                onChange={(data) => onChangeHandler(data.id, 'groupId')}
                                position={"bottom"}
                                customClasses={classes.margin20t}
                            />
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Space direction="horizontal" align="center">
                                <Button
                                    key="save"
                                    type="submit"
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn)}>OK</Button>
                                <Button
                                    key="cancel"
                                    color='primary'
                                    variant="contained"
                                    onClick={() => handleClose()}
                                    className={clsx(classes.AddMoreBtn)}>Cancel</Button>
                            </Space>
                        </div>
                    </Box>
                }
            />
            <ReportModal
                title={title}
                open={reportOpen}
                list={
                    <>
                        <div className={clsx(classes.downloadsReportHeading, classes.textAlignCenter)}>
                            <h4 className={classes.aTitle}>{title}</h4>
                            <p className={classes.downloadsHeading}></p>
                        </div>
                        {
                            customerAgedDuesLoader ? <div className={classes.loadMoreCircle}></div> : <>

                                <Row className={clsx(classes.bill, classes.billReportHead, classes.margin20t, classes.viewPrint, 'no-break')}>
                                    <Col span={3}><h6>Cust. ID</h6></Col>
                                    <Col span={6}><h6>Customer Name</h6></Col>
                                    <Col className={classes.textAlignRight} span={3}><h6>0-15 Days</h6></Col>
                                    <Col className={classes.textAlignRight} span={3}><h6>16-30 Days</h6></Col>
                                    <Col className={classes.textAlignRight} span={3}><h6>31-45 Days</h6></Col>
                                    <Col className={classes.textAlignRight} span={3}><h6> 45 Days</h6></Col>
                                    <Col className={classes.textAlignRight} span={3}><h6>Total</h6></Col>
                                </Row>
                                {
                                    customerAgedDuesDetails?.customerDues && customerAgedDuesDetails?.customerDues?.length > 0 ?
                                        customerAgedDuesDetails?.customerDues?.map((data, i) => (
                                            <Row key={i} className={clsx(classes.bill, 'no-break')}>
                                                <Col span={3}><p>{data?.customerSerialNo}</p></Col>
                                                <Col span={6}><p>{data?.customername}</p></Col>
                                                <Col className={classes.textAlignRight} span={3}><p>₹ {currencyFormat(data?.zeroTo15)}</p></Col>
                                                <Col className={classes.textAlignRight} span={3}><p>₹ {currencyFormat(data?.sixteenTo30)}</p></Col>
                                                <Col className={classes.textAlignRight} span={3}><p>₹ {currencyFormat(data?.thirtyOneTo45)}</p></Col>
                                                <Col className={classes.textAlignRight} span={3}><p>₹ {currencyFormat(data?.moreThan45)}</p></Col>
                                                <Col className={classes.textAlignRight} span={3}><p>₹ {currencyFormat(data?.totalDueBalance)}</p></Col>
                                            </Row>
                                        )) : <Row className={classes.noBorder}><Col span={24} style={{ textAlign: "center", marginTop: 15 }}>Sorry, we couldn’t find any data for the selected criteria. Please refine your filter</Col></Row>
                                }
                            </>
                        }
                    </>
                }
                businessDetails={businessDetails}
                handleClose={() => { setReportOpen(false); handleClose(); }}
            />
        </>
    )
}